export default __webpack_public_path__ + "static/media/Paid.73d3068d.svg";